import React from 'react';
import BaseNavBar from './baseNavBar';
import { getPresetStyle } from './handle';
export function NavBar(props) {
    // 根据mode获取预设样式
    const innerProps = getPresetStyle(props);
    return <BaseNavBar {...innerProps}/>;
}
